import React from 'react'

export function LockScreen({ pending, preparing, ready, audioEnabled, unlockCode, unlockInput, shakeError, onDigit, onClear, onBackspace, onScreenTouch }) {
  return (
    <div
      className="fixed inset-0 bg-gray-900/95 z-50 flex flex-col items-center justify-center"
      onClick={onScreenTouch}
    >
      {/* Order Status Summary */}
      <div className="mb-8 flex gap-8 text-white text-xl">
        <div className={`text-center ${pending > 0 ? 'rounded-lg px-4 py-2 animate-pulse ring-2 ring-red-500/75' : ''}`}>
          <div className={`text-4xl font-bold text-red-400`}>{pending}</div>
          <div className="text-gray-400">New</div>
        </div>
        <div className="text-center">
          <div className="text-4xl font-bold text-yellow-400">{preparing}</div>
          <div className="text-gray-400">Preparing</div>
        </div>
        <div className="text-center">
          <div className="text-4xl font-bold text-green-400">{ready}</div>
          <div className="text-gray-400">Ready</div>
        </div>
      </div>

      {/* Sound Status Indicator */}
      <div className={`mb-12 text-2xl font-semibold ${audioEnabled ? 'text-green-400' : 'text-red-400 animate-pulse'}`}>
        {audioEnabled ? '🔊 Sound On' : '🔇 Sound Off'}
      </div>

      {/* Unlock UI */}
      {unlockCode ? (
        <div className="text-center" onClick={(e) => e.stopPropagation()}>
          <p className="text-gray-400 mb-6 text-lg">Enter code to unlock</p>

          {/* Code dots */}
          <div className={`flex gap-3 mb-8 justify-center ${shakeError ? 'animate-shake' : ''}`}>
            {[0, 1, 2, 3, 4, 5].map((i) => (
              <div
                key={i}
                className={`w-4 h-4 rounded-full ${
                  i < unlockInput.length ? 'bg-white' : 'bg-gray-600'
                }`}
              />
            ))}
          </div>

          {/* Numeric keypad */}
          <div className="grid grid-cols-3 gap-3 max-w-xs mx-auto">
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((digit) => (
              <button
                key={digit}
                onClick={() => onDigit(String(digit))}
                className="w-20 h-20 bg-gray-700 hover:bg-gray-600 text-white text-2xl font-bold rounded-xl transition"
              >
                {digit}
              </button>
            ))}
            <button
              onClick={onClear}
              className="w-20 h-20 bg-gray-800 hover:bg-gray-700 text-gray-400 text-sm font-medium rounded-xl transition"
            >
              Clear
            </button>
            <button
              onClick={() => onDigit('0')}
              className="w-20 h-20 bg-gray-700 hover:bg-gray-600 text-white text-2xl font-bold rounded-xl transition"
            >
              0
            </button>
            <button
              onClick={onBackspace}
              className="w-20 h-20 bg-gray-800 hover:bg-gray-700 text-gray-400 text-2xl rounded-xl transition"
            >
              ←
            </button>
          </div>
        </div>
      ) : (
        <p className="text-gray-400 text-xl">Touch anywhere to unlock</p>
      )}
    </div>
  )
}
